import {
  ClientSummaryByPriority,
  HealthPromotion,
  Infographics,
  MoreInformation,
  Progress_VisitDataStatus,
} from '@ecdlink/graphql';
import { HcwHighlightsDto, VisitStatusDto } from '@ecdlink/core';
import { RootState } from '../types';

export const getVisitStatus = (state: RootState): VisitStatusDto | undefined =>
  state.visits.visitStatus;

export const getHealthPromotionSelector = (
  state: RootState
): HealthPromotion[] | undefined => state.visits.healthPromotion;

export const getInfographicsSelector = (
  state: RootState
): Infographics[] | undefined => state.visits.infographics;

export const getMoreInformationSelector = (
  state: RootState
): MoreInformation[] | undefined => state.visits.moreInformation;

export const getPreviousVisitInformationForInfantSelector = (
  state: RootState,
  visitIds: string[]
): Progress_VisitDataStatus | undefined => {
  const previousVisit = state.visits.previousVisitInformationForInfant;
  if (!previousVisit || !visitIds.includes(previousVisit?.visitId!)) {
    return undefined;
  }
  return previousVisit;
};

export const getVisitVideoBySectionAndLocale = (
  state: RootState,
  section: string,
  locale: string
) =>
  state.visits.visitVideos?.find(
    (item) => item?.section === section && item?.locale === locale
  );

export const getHealthCareWorkerHighlightsSelector = (
  state: RootState
): HcwHighlightsDto | undefined => state.visits.healthCareWorkerHighlights;

export const getPreviousVisitInformationForMotherSelector = (
  state: RootState,
  visitIds: string[]
): Progress_VisitDataStatus | undefined => {
  const previousVisit = state.visits.previousVisitInformationForMother;
  if (!previousVisit || !visitIds.includes(previousVisit?.visitId!)) {
    return undefined;
  }
  return previousVisit;
};

export const GetMotherSummaryByPrioritySelector = (
  state: RootState
): ClientSummaryByPriority[] | undefined =>
  state.visits.motherSummaryByPriority;

export const GetInfantSummaryByPrioritySelector = (
  state: RootState
): ClientSummaryByPriority[] | undefined =>
  state.visits.infantSummaryByPriority;
